<micro-lookup domain="smsc" obj="smscBinds" url="/smsc/smscBinds" [key]="smscBindId" [link]="link"></micro-lookup>
